// extracted by mini-css-extract-plugin
export var chip = "_fj-0";
export var filterDropdown = "_fj-5";
export var filterItem = "_fj-6";
export var icon = "_fj-1";
export var removeButton = "_fj-3";
export var removeIcon = "_fj-4";
export var separator = "_fj-2";